// extracted by mini-css-extract-plugin
export default {"normal":"normal--pSb2E","doTransition":"doTransition--NXA_5"};